"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.walkSyntax = exports.printSyntax = exports.parseSyntax = exports.locateSyntax = exports.getContext = exports.execSyntax = void 0;
var syntax_interpreter_1 = require("./syntax-interpreter");
Object.defineProperty(exports, "execSyntax", { enumerable: true, get: function () { return syntax_interpreter_1.execSyntax; } });
var get_context_1 = require("./syntax-interpreter/get-context");
Object.defineProperty(exports, "getContext", { enumerable: true, get: function () { return get_context_1.getContext; } });
var syntax_locator_1 = require("./syntax-locator");
Object.defineProperty(exports, "locateSyntax", { enumerable: true, get: function () { return syntax_locator_1.locateSyntax; } });
var syntax_parser_1 = require("./syntax-parser");
Object.defineProperty(exports, "parseSyntax", { enumerable: true, get: function () { return syntax_parser_1.parseSyntax; } });
var syntax_printer_1 = require("./syntax-printer");
Object.defineProperty(exports, "printSyntax", { enumerable: true, get: function () { return syntax_printer_1.printSyntax; } });
var syntax_walker_1 = require("./syntax-walker");
Object.defineProperty(exports, "walkSyntax", { enumerable: true, get: function () { return syntax_walker_1.walkSyntax; } });
//# sourceMappingURL=index.js.map